export default function TempsStandardPages(){
  return(
    <div>
      Template Standard Pages coming soon!
    </div>
  );
}